mutation EntityTagCardAccountCreate($input: EntityTagCardAccountCreateInput!) {
  entityTagCardAccountCreate(input: $input) {
    entityTags {
      id
      tagId
      entityId
      appId
    }
  }
}